import { Turbo } from "@hotwired/turbo-rails"

// <turbo-stream action="visit" url="/..." frame="side_page"></turbo-stream>
// frame で指定した turbo-frame が中身を持っていれば（開いていれば）その frame 内で遷移し、
// そうでなければページ全体を遷移する。
// 派生タスクの登録後に、side page で作ったなら side page のまま新しいタスクへ、
// 単体ページで作ったなら新しいタスクのページへ移るために使う
Turbo.StreamActions.visit = function () {
  const url = this.getAttribute("url")
  const frame = document.getElementById(this.getAttribute("frame"))
  if (frame && frame.firstElementChild) {
    frame.src = url
  } else {
    Turbo.visit(url)
  }
}
